export default __webpack_public_path__ + "static/media/campfire.9af52bd5.png";